// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic-summary__header{padding:20px;background-color:#f5f5f5;border-top-left-radius:4px;border-top-right-radius:4px}", ""]);
// Exports
module.exports = exports;
